<template>
	<template v-if="this.options?.name && this.options?.name?.length > 0">
		<label
				:for="this.options?.slug"
				class="input-unit__label"
				:class="{'required': this.options?.required}"
		>
            <span>
                {{ this.options?.name }}
            </span>
			<span
					v-if="this.options?.secondaryLabel && this.options?.secondaryLabel?.length > 0"
					class="input-unit__label--secondary"
			>
                {{ this.options?.secondaryLabel }}
            </span>
		</label>
	</template>

	<textarea
			:class="{
				'input-unit': true,
				'error': this.options?.errorState ?? false,
				[this.options?.class ?? '']: true,
			}"
			:name="this.options?.slug"
			:id="this.options?.slug"
			:value="this.modelValue"
			:placeholder="this.options?.placeholder ?? ''"
			:minlength="this.options?.minlength ?? null"
			:maxlength="this.options?.maxlength ?? null"
			:required="this.options?.required ?? false"
			:readonly="(this.options?.readonly || this.options?.class?.includes('only-text')) ?? false"
			:cols="this.options?.cols ?? null"
			:rows="this.options?.rows ?? null"
			@input='this.$emit("update:modelValue", $event.target.value)'
	></textarea>

	<small
			v-show="this.options?.infoText && this.options?.infoText?.length > 0"
			:id="this.options?.slug+'_info'"
			class="mt-1 input-unit__label--secondary"
	>
		{{ this.options?.infoText }}
	</small>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {TextareaUnitOptions} from "./Interfaces/TextareaUnitOptions";

export default defineComponent({
	name: "TextareaUnit",
	emits: ["update:modelValue"],
	props: {
		options: {
			type: Object as PropType<TextareaUnitOptions>,
			required: true,
		},
		modelValue: {
			type: [String, Number],
			default: '',
			required: false,
		},
	},
});
</script>

<style scoped>
</style>
